export default [
  {
    path: '/stock-store',
    name: 'StockStore',
    meta: {
      title: '原料库存'
    },
    component: () => import('@/views/StockStore')
  },
  {
    path: '/stock-store-info',
    name: 'StockStoreInfo',
    meta: {
      title: '库存明细'
    },
    component: () => import('@/views/StockStore/StockStoreInfo')
  }
]
